<template>
    <!-- components/my-dialog/my_dialog.wxml -->
    <div class="my_dialog_wrapper" v-if="info.dialogShow">
        <div class="common-wrap my_dialog">
            <div class="title">{{ info.title }}</div>
            <div :class="item.class" @click="parseEventDynamicCode(item.class == 'order_number' ? 'copy' : 'handleClick')" v-for="(item, index) in info.contents" :key="index">
                <span>{{ item.text }}</span>
            </div>
            <div class="btn_list">
                <div :class="item.class" @click="handleClick(item)"  v-for="(item, index) in info.buttons" :key="index">
                    <span>{{ item.text }}</span>
                </div>
            </div>
        </div>
        <div class="meng_layer" @click="handleClose"></div>
    </div>
</template>

<script>
// components/common-dialog/common_dialog.js
export default {
    data() {
        return {};
    },
    /**
     * 组件的属性列表
     */
    props: {
        info: {
            type: Object
        }
    },
    /**
     * 组件的方法列表
     */
    methods: {
        handleClose() {
            const { info } = this;

            if (info.buttons[0].funcName == 'routerLink') {
                this.$emit('routerLink');
            } else {
                this.info.dialogShow = false
            }
        },

        handleClick(item) {

            if (!item.funcName) {
                return;
            }

            this.$emit(item.funcName);
        },

        copy() {
            //复制文本
            // console.log('复制文本')
        }
    }
};
</script>
<style>
@import './my_dialog.less';
</style>
